define('presentation/promptDialog/presentationObjects/linePresentationObject',[],function() {
    return function(){
        var self = this;

        self.lineStyle = null;
        self.lineText = null;
    };
});

